import { UploadDocumentJob } from '@domain/types';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  trackUploadFailed,
  trackUploadStarted,
  trackUploadSucceeded,
  uploadTrackingContextFromJob,
} from '@services/analytics/uploadAnalytics';
import { IntegrationsActions } from '@store/integrations/integrations.slice';
import { UploadJobFailurePayload, UploadJobSuccessPayload } from '@store/upload/upload.reducer';
import { UploadDocumentsActions } from '@store/uploadDocuments/uploadDocuments.slice';
import { all, takeEvery } from 'redux-saga/effects';

export function trackJobUploadStarted({ payload: job }: PayloadAction<UploadDocumentJob>) {
  trackUploadStarted(uploadTrackingContextFromJob(job));
}

export function trackJobUploadSucceed({
  payload: { job, documentId },
}: PayloadAction<UploadJobSuccessPayload>) {
  trackUploadSucceeded(uploadTrackingContextFromJob(job), documentId);
}

export function trackJobUploadFailed({
  payload: { job, errors },
}: PayloadAction<UploadJobFailurePayload>) {
  trackUploadFailed(uploadTrackingContextFromJob(job), errors[0]);
}

export function* trackingUploadJobActionsSaga() {
  yield all([takeEvery(UploadDocumentsActions.addUploadJob.type, trackJobUploadStarted)]);
  yield all([takeEvery(IntegrationsActions.addUploadJob.type, trackJobUploadStarted)]);
  yield all([takeEvery(UploadDocumentsActions.jobUploadFailure.type, trackJobUploadFailed)]);
  yield all([takeEvery(UploadDocumentsActions.jobUploadSuccess.type, trackJobUploadSucceed)]);
  yield all([takeEvery(IntegrationsActions.jobUploadFailure.type, trackJobUploadFailed)]);
  yield all([takeEvery(IntegrationsActions.jobUploadSuccess.type, trackJobUploadSucceed)]);
}
